import { QueueNumber } from "@dqm/queue-number";
import { PrintError } from "../../error/PrintError";

export class PrintingService {
  async print(qn: QueueNumber): Promise<void> {
    const body = JSON.stringify(qn);

    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    const request = new Request("http://localhost:4404/print/queue-number", {
      method: "POST",
      body,
      headers,
    });
    let response;

    try {
      response = await fetch(request);
    } catch (err) {
      throw new PrintError(
        "PrintingService: print failed, cannot connect to printer api"
      );
    }

    if (response.status !== 204) {
      throw new PrintError("PrintingService: print failed");
    }

    return;
  }
}
